/* Angular modules */
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CtaClickEventDatalayerService} from '../../shared/google-analytics/cta-click-event-datalayer.service';
import {Router} from '@angular/router';
import {SessionStorage} from 'ngx-webstorage';
import {Item, Project} from '../../project/shared/project-model';


@Injectable()
export class BomMailService {

  @SessionStorage()
  currentProject: Project;

  @SessionStorage()
  currentItemct: Item;

  constructor( private httpClient: HttpClient,
               private ctaClickEventDatalayerService: CtaClickEventDatalayerService,
               private router: Router) {
  }

  sendMail (formData): Observable<any> {
    this.ctaClickEventDatalayerService.CtaClickEvent('Order by Mail', this.currentItemct?.id, this.currentItemct?.name);
    return this.httpClient.post('/order/sendMail', formData);
  }

  /**
   * Check if we add file the total files size does not exceed the max size
   * @param files already added files
   * @param file file to add
   * @param maxSize files size allowed
   * @returns {boolean}
   */
  canAddAttachementFile(attachments, file, maxSize) {
    let filesSize = file.size;
    attachments.forEach((attachment) => {
      filesSize += attachment.file.size;
    });
    return filesSize / (1024 * 1024) <= maxSize ;
  }

}
